"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccepterBlock = void 0;
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var SignedSlot_1 = require("@CommonFrontend/Public/Widgets/EsignComponents/SignatureSlot/SignedSlot");
var SignatureSlot_1 = require("@CommonFrontend/Public/Widgets/EsignComponents/SignatureSlot/SignatureSlot");
var c = (0, BemBuilder_1.default)("accepter-block");
var AccepterBlock = (function (_super) {
    __extends(AccepterBlock, _super);
    function AccepterBlock() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.formatDate = function () {
            var date = _this.props.date;
            return new Date(date).toLocaleDateString();
        };
        return _this;
    }
    AccepterBlock.prototype.render = function () {
        var _a = this.props, name = _a.name, esignature = _a.esignature;
        var hasEsignature = !!esignature;
        return (react_1.default.createElement("div", { className: c("signed-slot-container") },
            react_1.default.createElement(SignedSlot_1.SignedSlot, { dateStamp: this.formatDate(), name: name, size: "large", data: esignature !== null && esignature !== void 0 ? esignature : "", labelStyle: hasEsignature ? "name" : "field", type: hasEsignature ? SignatureSlot_1.SlotType.Signature : "no-signature" })));
    };
    return AccepterBlock;
}(react_1.default.Component));
exports.AccepterBlock = AccepterBlock;
